import React, { createContext, useContext, useState } from 'react';

const GlobalContext = createContext();

export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useGlobalContext must be used within GlobalProvider');
  }
  return context;
};

export const GlobalProvider = ({ children }) => {
  const [user, setUser] = useState('Owlex');

  const navMenuItems = [
    { id: 1, label: 'Home', route: '/' },
    { id: 2, label: 'Pricing Plans', route: '#pricing' },
    { id: 3, label: 'Contact Us', route: '#contact' },
    { id: 4, label: 'Documentation', route: '/documentation' }
  ];

  const value = {
    user,
    setUser,
    navMenuItems
  };

  return (
    <GlobalContext.Provider value={value}>
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalContext;

